import type { ReactNode } from "react"

import { cn } from "../lib/cn"

export type PageHeaderProps = {
  title: ReactNode
  titleMeta?: ReactNode
  titleClassName?: string
  description?: ReactNode
  eyebrow?: ReactNode
  action?: ReactNode
  className?: string
}

export function PageHeader({
  title,
  titleMeta,
  titleClassName,
  description,
  eyebrow,
  action,
  className,
}: PageHeaderProps) {
  return (
    <div
      data-slot="page-header"
      className={cn(
        "flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between",
        className,
      )}
    >
      <div className="flex min-w-0 flex-col gap-1">
        {eyebrow != null && (
          <p className="m-0 text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
            {eyebrow}
          </p>
        )}
        <div className="flex flex-wrap items-center gap-3">
          <h1
            className={cn(
              "m-0 font-display text-2xl font-semibold tracking-tight text-foreground",
              titleClassName,
            )}
          >
            {title}
          </h1>
          {titleMeta}
        </div>
        {description != null && (
          <p className="m-0 max-w-2xl text-sm text-muted-foreground">
            {description}
          </p>
        )}
      </div>
      {action != null && <div className="max-w-full shrink-0">{action}</div>}
    </div>
  )
}
